import { useUser } from '@/modules/auth/hooks';

import { deriveViewState } from '../utilities/deriveViewState';
import { useViewFilter } from './useViewFilter';

export const useIsViewingAsOther = (): boolean => {
    const user = useUser();
    const { viewFilter } = useViewFilter();

    return deriveViewState(viewFilter, user?.id) === 'other';
};
